import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["alt"]
const _hoisted_2 = ["alt"]

import {
  RcDropdown,
  RcDropdownTrigger,
  RcDropdownItemCheckbox,
  RcDropdownItemSelect,
} from '@components/RcDropdown';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContainerLogsActions',
  props: {
  range: {
    type:    String,
    default: '',
  },
  rangeOptions: {
    type: Array,
    default() {
      return [];
    },
  },
  wrap:       Boolean,
  timestamps: Boolean,
},
  emits: [
  'toggleRange',
  'toggleWrap',
  'toggleTimestamps',
],
  setup(__props) {






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RcDropdown), null, {
    dropdownCollection: _withCtx(() => [
      _createVNode(_unref(RcDropdownItemSelect), {
        "model-value": __props.range,
        options: __props.rangeOptions,
        label: _ctx.t('wm.containerLogs.range.label'),
        onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleRange', $event)))
      }, null, 8, ["model-value", "options", "label"]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      _createVNode(_unref(RcDropdownItemCheckbox), {
        "model-value": __props.wrap,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleWrap', $event)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('wm.containerLogs.wrap')), 1)
        ]),
        _: 1
      }, 8, ["model-value"]),
      _cache[5] || (_cache[5] = _createTextVNode()),
      _createVNode(_unref(RcDropdownItemCheckbox), {
        "model-value": __props.timestamps,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleTimestamps', $event)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('wm.containerLogs.timestamps')), 1)
        ]),
        _: 1
      }, 8, ["model-value"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(RcDropdownTrigger), { class: "condensed" }, {
        after: _withCtx(() => [
          _createElementVNode("i", {
            class: "icon icon-chevron-up",
            alt: _ctx.t('wm.containerLogs.expand')
          }, null, 8, _hoisted_2)
        ]),
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: "icon icon-gear",
            alt: _ctx.t('wm.containerLogs.options')
          }, null, 8, _hoisted_1),
          _cache[3] || (_cache[3] = _createTextVNode())
        ]),
        _: 1,
        __: [3]
      }),
      _cache[6] || (_cache[6] = _createTextVNode())
    ]),
    _: 1,
    __: [6]
  }))
}
}

})